import { Injectable } from '@angular/core';
import { AppSettingsService } from '../appsettings/app-settings.service';

@Injectable({ providedIn: 'root' })
export class FeatureService {
  constructor(private appsettingsService: AppSettingsService) {}

  isFeatureEnabled(feature: string): boolean {
    const featureFlags = this.appsettingsService.appSettings.featureFlags;
    if (!featureFlags) {
      return false;
    }
    return featureFlags[feature] ?? false;
  }
}
